import {Map, List, fromJS} from 'immutable';
import axios from "axios";

if (sessionStorage.getItem("authToken")) {
    axios.defaults.headers.common['Auth-Token'] = sessionStorage.getItem("authToken");
}

export const types = {
    INIT: 'SCHEDULEDREPLENISHMENT/INIT',
    FETCH_SCHEDULED_REPLENISHMENTS: 'SCHEDULEDREPLENISHMENT/FETCH_SCHEDULED_REPLENISHMENTS',
    FETCH_SCHEDULED_REPLENISHMENT_SUCCESS: 'SCHEDULEDREPLENISHMENT/FETCH_SCHEDULED_REPLENISHMENT_SUCCESS',
    UPDATE_QUERY: 'SCHEDULEDREPLENISHMENT/UPDATE_QUERY',
    UPDATE_PROCESSING_STATUS_FILTER: 'SCHEDULEDREPLENISHMENT/UPDATE_PROCESSING_STATUS_FILTER',
    CHANGE_PAGE: 'SCHEDULEDREPLENISHMENT/CHANGE_PAGE',
    SET_PAGE_SIZE: 'SCHEDULEDREPLENISHMENT/SET_PAGE_SIZE',
    UPDATE_SORT_PROPERTIES: 'SCHEDULEDREPLENISHMENT/UPDATE_SORT_PROPERTIES'
};

export const initialState = fromJS({
    replenishments: [],
    filters: {
        processingStatus: 'OPEN'
    },
    sortProperties: {
        propertyToSortBy: 'id',
        sortDirection: 'asc'
    },
    pagination: {
        page: 0,
        pageSize: 25,
        totalPages: 0,
        totalElements: 0
    },
    query: ''
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.FETCH_SCHEDULED_REPLENISHMENT_SUCCESS:
            return state.set('replenishments', fromJS(action.replenishments))
                .setIn(['pagination', 'totalPages'], fromJS(action.totalPages))
                .setIn(['pagination', 'totalElements'], fromJS(action.totalElements));
        case types.UPDATE_QUERY:
            return state.set('query', action.query).setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_PROCESSING_STATUS_FILTER:
            return state.setIn(['filters', 'processingStatus'], action.status).setIn(['pagination', 'page'], fromJS(0));
        case types.CHANGE_PAGE:
            return state.setIn(['pagination', 'page'], fromJS(action.page));
        case types.SET_PAGE_SIZE:
            return state.setIn(['pagination', 'pageSize'], fromJS(action.pageSize))
                .setIn(['pagination', 'page'], fromJS(0));
        case types.UPDATE_SORT_PROPERTIES:
            return state.setIn(['sortProperties', 'propertyToSortBy'], fromJS(action.propertyToSortBy))
                .setIn(['sortProperties', 'sortDirection'], fromJS(action.sortDirection));
        default:
            return state
    }
};

export const initialise = () => {
    return (dispatch) => {
        dispatch(fetchScheduledReplenishments());
    }
};

export const fetchScheduledReplenishments = () => {
    return function (dispatch, getState) {

        const {query, filters, pagination, sortProperties} = getState().scheduledReplenishment.toJS();

        const path = __API__ +
            `/api/ui/scheduledreplenishment?search=${query}&processingStatus=${filters.processingStatus}&page=${pagination.page}&pageSize=${pagination.pageSize}&propertyToSortBy=${sortProperties.propertyToSortBy}&sortDirection=${sortProperties.sortDirection}`;

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(data => {
                dispatch(fetchScheduledReplenishmentsSuccess(data.content, data.totalPages, data.totalElements));
            })
            .catch(error => {
                console.log(error);
            });
    }
};

export const fetchScheduledReplenishmentsSuccess = (replenishments, totalPages, totalElements) => {
    return {
        type: types.FETCH_SCHEDULED_REPLENISHMENT_SUCCESS,
        replenishments: replenishments,
        totalPages: totalPages,
        totalElements: totalElements
    };
};

export const releaseScheduledReplenishment = (replenishmentId, quantity) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/scheduledreplenishment/release`;

        const command = {
            scheduledReplenishmentIds: [replenishmentId],
            quantity: quantity
        };

        return axios.put(path, command)
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchScheduledReplenishments());
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchScheduledReplenishmentsSuccess([]));
            });
    }
};

export const deleteScheduledReplenishment = (replenishmentId) => {
    return function (dispatch) {
        return dispatch(deleteScheduledReplenishments([replenishmentId]));
    }
};

export const deleteScheduledReplenishments = (replenishmentIds) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/scheduledreplenishment';
        const command = {
            replenishmentIdsToDelete: replenishmentIds
        };

        return axios.delete(path, {data: command})
            .then(response => {
                return response.data;
            })
            .then(() => {
                dispatch(fetchScheduledReplenishments());
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchScheduledReplenishmentsSuccess([]));
            });
    }
};


export const updateQuery = (query) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_QUERY,
            query: query
        });
        dispatch(fetchScheduledReplenishments());
    }
};

export const updateStatusFilter = (status) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_PROCESSING_STATUS_FILTER,
            status: status
        });
        dispatch(fetchScheduledReplenishments());
    };
};

export const updatePage = (newPage) => {
    return {
        type: types.CHANGE_PAGE,
        page: newPage
    }
};

export const changePage = (newPage) => {
    return function (dispatch) {
        dispatch(updatePage(newPage));
        dispatch(fetchScheduledReplenishments());
    }
};

export const setPageSize = (pageSize) => {
    return function (dispatch) {
        dispatch({
            type: types.SET_PAGE_SIZE,
            pageSize: pageSize
        });
        dispatch(fetchScheduledReplenishments());
    }
};

export const updateSortProperty = (propertyToSortBy) => {
    return function (dispatch, getState) {
        const {sortProperties} = getState().scheduledReplenishment.toJS();
        const asc = 'asc';
        const desc = 'desc';
        let sortDirection = 'asc';
        if (sortProperties.propertyToSortBy === propertyToSortBy) {
            sortDirection = sortProperties.sortDirection === asc ? desc : asc;
        }
        dispatch({
            type: types.UPDATE_SORT_PROPERTIES,
            propertyToSortBy: propertyToSortBy,
            sortDirection: sortDirection
        });
        dispatch(fetchScheduledReplenishments());
    }
};


// WEBPACK FOOTER //
// ./src/admin/scheduledreplenishment/reducer.js